import Rails from '@rails/ujs'
import '../controllers/car/alpine/simulation/table'
import '../controllers/car/alpine/simulation/container'
import './alpine'
import '../controllers/car'
import '../css/car.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
